//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').directive('loadable', [
    '$timeout',
    '$window',
    function(
            $timeout,
            $window,
        ) {
      return {
        scope: {
          dependency: '=',
          height: '@',
          message: '@',
                    // Callback which is fired after the inner-content ".show" call is complete. Useful to synchronizing animations
          onLoaderHidden: '&?',
        },
        restrict: 'E',
        link(scope, element, attrs) {
          scope.continuous = typeof attrs.continuous !== 'undefined';
          const loadingMessage = scope.message ?
                        `<div class='curalate-loading-bar-message' style='top: ${scope.height / 2 + 30}px;'>${scope.message}</div>` : '';

          const loadingChildren = angular.element(element).children();
          const loadingBarStyle = 'height' in attrs ? `height: ${scope.height}px` : '';
          const loadingBarHtml =
                        `<div class="curalate-loading-bar col-xs-12" style="${loadingBarStyle}">` +
                        '<div class="curalate-loading-spinner-wrapper">' +
                        `</div>${loadingMessage
                            }</div>`;

          angular.element(element).append(loadingBarHtml);

          const loadingBar = angular.element(element).find('.curalate-loading-bar');

          function showLoader() {
            loadingChildren.hide();
            loadingBar.show();
          }

          function hideLoader() {
            loadingBar.hide();
            loadingChildren.show();
            $timeout(() => {
              if (scope.onLoaderHidden && _.isFunction(scope.onLoaderHidden())) {
                scope.onLoaderHidden()();
              }
            });
          }

          showLoader();

          const unregister = scope.$watch('dependency', () => {
            if (scope.dependency) {
              hideLoader();
                            // Trigger resize event so elements which depend on "loadingChildren"'s dimensions
                            // get properly updated (I'm looking at you, Highcharts)
              angular.element($window).trigger('resize');
              if (!scope.continuous) {
                unregister();
              }
            } else {
              showLoader();
            }
          });
        },
      };
    },
  ]);
})();
